export const showLeadNotification = (lead) => {
  if (!('Notification' in window)) return;

  if (Notification.permission === 'granted') {
    new Notification('🚀 New Lead Alert', {
      body: `👤 ${lead.FullName}
📧 ${lead.Email ?? 'N/A'}
🎯 ${lead.LeadCategory}
📍 ${lead.EnrollmentType ?? 'N/A'}`,
      icon: '/alert.png',
      tag: 'new-lead',       // prevents spam
      renotify: true,
    });
  }
};
